import { AreaActivities } from './areaActivities.model';
import { Jobs } from "./jobs.model";
import { environment } from 'src/environments/environment';

export class Companies {
  private id: number;
  private name: string;
  private acronym: string;
  private description: string;
  private email: string;
  private mail_inbox: string;
  private phone_1: string;
  private phone_2: string;
  private city: string;
  private country: string;
  private address: string;
  private logo: string;
  private nb_person: string;
  private token: string;
  private website_link: string;
  private name_creator: string;
  private position_creator: string;
  private area_activity: AreaActivities;
  private nb_jobs: number;
  private jobs: Jobs[];

  constructor(Companies: any) {
    this.id = Companies.id;
    this.name = Companies.name;
    this.acronym = Companies.acronym;
    this.description = Companies.description;
    this.email = Companies.email;
    this.mail_inbox = Companies.mail_inbox;
    this.phone_1 = Companies.phone_1;
    this.phone_2 = Companies.phone_2;
    this.city = Companies.city;
    this.country = Companies.country;
    this.address = Companies.address;
    this.logo = Companies.logo;
    this.nb_person = Companies.nb_person;
    this.token = Companies.token;
    this.website_link = Companies.website_link;
    this.name_creator = Companies.name_creator;
    this.position_creator = Companies.position_creator;
    this.area_activity = Companies.area_activity; (Companies.area_activity != undefined) ? new AreaActivities(Companies.area_activity) : new AreaActivities({});
    this.nb_jobs = Companies.nb_jobs;
    this.jobs = Companies.jobs;
  }

  getId(): number {
    return this.id;
  }

  getName(): string {
    return this.name;
  }

  getAcronym(): string {
    return this.acronym;
  }

  getDescription(): string {
    return this.description;
  }

  getEmail(): string {
    return this.email;
  }

  getMailInbox(): string {
    return this.mail_inbox;
  }

  getPhone1(): string {
    return this.phone_1;
  }

  getPhone2(): string {
    return this.phone_2;
  }

  getCity(): string {
    return this.city;
  }

  getCountry(): string {
    return this.country;
  }

  getAddress(): string {
    return this.address;
  }

  getLogo(): string {
    return (this.logo != null && this.logo != '') ? environment.apiUrl + this.logo : this.logo;
  }

  getNbPerson(): string {
    return this.nb_person;
  }

  getToken(): string {
    return this.token;
  }
  getWebsiteLink(): string {
    return this.website_link;
  }

  getNameCreator(): string {
    return this.name_creator;
  }

  getPositionCreator(): string {
    return this.position_creator;
  }

  getAreaActivity(): AreaActivities {
    return this.area_activity;
  }

  getNbJobs(): number {
    return this.nb_jobs;
  }

  getJobs(): Jobs[] {
    return this.jobs;
  }

}